import Image from 'next/image';
import React, { useState } from 'react';

import { useCitySelectedContext } from '../../contexts/city-context/CityContext';
import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

interface NextImageV2Props {
  src: string;
  height?: number;
  width?: number;
  fill?: boolean;
  quality?: number;
  alt: string;
  fallbackSrc?: string;
  priority?: boolean;
  className?: string;
}

function NextImageV2({
  src,
  height,
  width,
  fill,
  quality = 75,
  alt,
  fallbackSrc,
  priority = false,
  className,
}: NextImageV2Props): React.ReactElement {
  const [imgSrc, setImgSrc] = useState(src);
  const cityContext = useCitySelectedContext();

  const handleError = (): void => {
    publishGa4Events(cityContext.category, 'Image Broken', 'Image Broken at: ' + alt);
    if (fallbackSrc) {
      setImgSrc(fallbackSrc);
    } else {
      setImgSrc('');
    }
  };

  return (
    <Image
      src={imgSrc}
      height={height}
      width={width}
      fill={fill}
      className={className}
      alt={alt}
      quality={quality}
      priority={priority}
      onError={handleError}
    />
  );
}

export default NextImageV2;
